const theme = {
  colors: {
    bgSecondary: "#F0F5F2",
    primary: "#1C1C1C",
    secondary: "#fdb913",
    tertiary: "#F0F5F2",
    text: "#fff",
    warn: "#fec300",
    danger: "#f65e5e",
    success: "#008940",
    textPrimary: '#FFCE76',
    buttonPrimary: '#D8D8D8'
  },
};

export default theme;
